/* @flow weak */
import cx from 'classnames';
import React from 'react';
import TrackedInput from 'components/TrackedInput.jsx';

class CardNumberInput extends React.Component {
  static propTypes = {
    onChange: React.PropTypes.func,
    value: React.PropTypes.string,
  };

  static contextTypes = {
    eventScreenName: React.PropTypes.string,
  };

  state = {
    value: this.props.value || '',
  }

  getFormattedValue(value) {
    const type = window.Stripe ? window.Stripe.card.cardType(value) : null;

    switch (type) {
      case 'American Express':
        const values = value.split('');

        values.splice(4, 0, ' ');
        values.splice(11, 0, ' ');

        return values.join('').trim();
      default:
        return value.replace(/(.{4})/g, '$1 ').trim();
    }
  }

  handleChange(event) {
    const value = event.target.value.split('').filter(char =>
      !isNaN(parseInt(char, 10))
    ).join('');

    this.setState({ value });

    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  render() {
    return (
      <TrackedInput
        {...this.props}
        type="tel"
        autoComplete="cc-number"
        className={cx('cc-number', this.props.className)}
        maxLength="19"
        placeholder="0000 0000 0000 0000"
        value={this.getFormattedValue(this.state.value)}
        onChange={this.handleChange.bind(this)}
        eventScreenName={this.context.eventScreenName}
        eventElementName="add_credit_card_number"
      />
    );
  }
}

export default CardNumberInput;



// WEBPACK FOOTER //
// ./src/payments/components/CardNumberInput.jsx